<template>
  <div class="relative router-view" :class="containerClass">
    <OverlaySpinner v-if="loading" :fixed="fixed" />
    <router-view />
  </div>
</template>

<script>
  import OverlaySpinner from "@ui/OverlaySpinner.vue";

  export default {
    name: "RouterViewWithLoader",
    components: {
      OverlaySpinner,
    },
    props: {
      fixed: {
        type: Boolean,
        default: false
      },
      containerClass: {
        type: String,
        default: ''
      }
    },
    computed: {
      loading() {
        return this.$store.state.loading;
      }
    },
  };
</script>

<style scoped>
  .router-view {
    min-height: 300px;
  }

</style>
